import { TraceLoggingHelpers } from "../helpers/trace-logging-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class MarketingWebChartXAxisPlotLineComponent implements IComponent {
    public id = 'x-axis-plot-line';

    private base: IChartContainer;
    private price = 0;
    private color = '';
    private setYAxisHeightOnly = false;
    private up = false;

    constructor(base: IChartContainer, price: number, color: string, setYAxisHeightOnly: boolean, up: boolean) {
        this.id += '-' + base.id;
        this.base = base;
        this.price = price;
        this.color = color;
        this.setYAxisHeightOnly = setYAxisHeightOnly;
        this.up = up;
        this.init();
    }

    public remove() {
        const yAxis: any = this.base.tiChartSeries?.highStockChart?.yAxis?.[0];
        if (!yAxis) {
            return;
        }

        yAxis.removePlotLine(this.id);
    }

    private createSytle(extraClass: string) {
        this.removeStyle();
        const className = this.id;

        let strokeWidth = '2';
        let strokeDasharray = '10, 15';

        if (this.base.tiChartSeries.chartElement.clientWidth <= 125) {
            strokeWidth = '1';
            strokeDasharray = '3, 5'
        }        

        let styleTag = `<style>`;
        styleTag += `.highcharts-plot-line.${className} {stroke: ${this.color} !important; stroke-dasharray: ${strokeDasharray} !important; stroke-width: ${strokeWidth}px !important; ${extraClass}}`;
        styleTag += `</style>`;

        const chartStyleContainer = `<div class="style-${className}">${styleTag}</div>`;
        this.base.tiChartSeries?.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    private removeStyle() {
        const highChartStyle = this.base.tiChartSeries?.element?.findFirst('.style-' + this.id);
        if (highChartStyle) {
            highChartStyle.remove();
        }
    }

    private init() {
        const yAxis = this.base.tiChartSeries?.highStockChart?.yAxis?.[0];
        if (yAxis) {
            
            let extraClass = '';
            let price = this.price;
            if (price <= yAxis.min) {
                price = yAxis.min;
                extraClass = `transform: translateY(3%);`;
            } else if (price >= yAxis.max) {
                price = yAxis.max;
                extraClass = `transform: translateY(-3%);`;
            }

            if (this.base.element.clientWidth <= 125) {
                extraClass = `transform: unset;`;
            }        
    
            this.createSytle(extraClass);

            if (extraClass) {
                if (this.up) {
                    yAxis.update({
                        height: '90%'
                    }, true);
                } else {
                    yAxis.update({
                        top: '10%',
                        height: '90%'
                    }, true);
                }
            } else {
                yAxis.update({
                    height: '100%'
                }, true);
            }

            if (this.setYAxisHeightOnly) {
                return;
            }

            yAxis.addPlotLine({
                value: price,
                className: this.id,
                width: 1,
                id: this.id,
                zIndex: 13,
                label: {
                    formatter: () => {
                        return '';
                    },
                    className: this.id,
                    useHTML: true
                },
            } as any);
        }
    }
}